<script setup lang="ts">
import { computed } from 'vue'
import { useRouter } from 'vue-router'

const props = defineProps<{ params?: { data?: any } }>()
const router = useRouter()

const href = computed(() => {
  const uuid = props.params?.data?.uuid
  return uuid ? `/dashboard/order/${uuid}` : null
})

const text = computed(() => props.params?.data?.quote?.quoteReference ?? '-')

const parentUuid = computed<string | null>(() => props.params?.data?.parentalOrderUuid ?? null)
const parentQuoteRef = computed<string | null>(() => props.params?.data?.parentalOrder?.quote?.quoteReference ?? null)
const followParentWorkflow = computed<boolean>(() => Boolean(props.params?.data?.followParentWorkflow))
const childCount = computed<number>(() => Number(props.params?.data?._count?.childOrders ?? 0))

const isChild = computed(() => Boolean(parentUuid.value))
const isParent = computed(() => !isChild.value && childCount.value > 0)

const childTooltip = computed(() => {
  const ref = parentQuoteRef.value ?? 'commande principale'
  const mode = followParentWorkflow.value ? 'suit la commande principale' : 'commande indépendante'
  return `Liée à ${ref} — ${mode}`
})

const parentTooltip = computed(() => {
  const n = childCount.value
  return `Commande principale — ${n} liaison${n > 1 ? 's' : ''}`
})

function onClick(e: MouseEvent) {
  if (!href.value) return
  e.preventDefault()
  if (e.ctrlKey || e.metaKey) {
    window.open(href.value, '_blank')
  } else {
    router.push(href.value)
  }
}

function onParentBadgeClick(e: MouseEvent) {
  if (!parentUuid.value) return
  e.preventDefault()
  e.stopPropagation()
  const url = `/dashboard/order/${parentUuid.value}`
  if (e.ctrlKey || e.metaKey) {
    window.open(url, '_blank')
  } else {
    router.push(url)
  }
}
</script>

<template>
  <div class="flex items-center gap-1.5">
    <span
      v-if="isParent"
      :title="parentTooltip"
      class="inline-block h-2 w-2 rounded-full bg-indigo-500 shrink-0"
    />
    <span
      v-else-if="isChild"
      :title="childTooltip"
      class="inline-block h-2 w-2 rounded-full bg-amber-500 shrink-0 cursor-pointer"
      @click="onParentBadgeClick"
    />

    <a v-if="href" :href="href" class="link link-primary hover:underline" @click="onClick">{{ text }}</a>
    <span v-else>{{ text }}</span>
  </div>
</template>
